import cn from 'classnames';
import * as React from 'react';

import { UISizeEnum } from '../../types/shell';

import styles from './Loader.module.scss';

interface IProps {
  isLoading?: boolean | undefined;
  style?: any;
  className?: string;
  spinnerClassName?: string;
  size?: UISizeEnum;
  lowPriority?: boolean;
}

const Loader = ({
  className,
  spinnerClassName,
  lowPriority = false,
  isLoading = false,
  style,
  size = UISizeEnum.Normal,
}: IProps) => {
  return isLoading ? (
    <div className={cn(styles.loader, className, { [styles.lowPriority]: lowPriority })} style={style}>
      <div className={cn(styles.spinner, styles[size], spinnerClassName)} />
    </div>
  ) : null;
};

export default Loader;
